import convertToServerTime from "./convertToServerTime";

/**
 * Returns today server date
 */
export const getTodayServerDate = ():Date => (
    convertToServerTime(new Date())
)